import { render, staticRenderFns } from "./LackFreeAccountDialog.vue?vue&type=template&id=2219fe5e&scoped=true"
import script from "./LackFreeAccountDialog.vue?vue&type=script&lang=js"
export * from "./LackFreeAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./LackFreeAccountDialog.vue?vue&type=style&index=0&id=2219fe5e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2219fe5e",
  null
  
)

export default component.exports